module.exports = __webpack_public_path__ + "static/media/icon-transmission.07c57e0e.svg";